/* Queries */
import { sbRespRoot } from '../../queries/sbRespRoot.js';

/* Reducers */
import { defaultReducers, actionSanitizer } from '../../reducers/reducerUtils.js';
import { sbSharedReducers } from '../../reducers/sbSharedReducers.js';
import { sbRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/sbRespNotificationsReducer.js';

/* Components */
import { SbRespLayout } from '../../finding/SbRespLayout/SbRespLayout.tsx';

/* Helpers */
import { createEntry } from '../createEntry.jsx';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { datadog, initSharedDatadogRum, sbTypes } from 'dibs-datadog/exports/datadog.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import SV from 'server-vars';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

/* Notifications */
import { sbRespNotifications } from '../../finding/SbRespNotifications/sbRespNotifications.js';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    notifications: sbRespNotifications,
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
        sharedNotificationsReducer,
    },
    state: SV.get('storeState'),
    actionSanitizer,
};
const isSearch = (SV.get('relay.variables.uriRef') || '').startsWith('/search/');
datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        device: 'resp',
        page: PAGE_TYPE.BROWSE,
        pageSubType: isSearch ? sbTypes.search : sbTypes.browse,
    });
    setDatadogABTestValues();
});
initializeDBL(options).then(({ store, queue, actions }) => {
    createEntry({
        Container: SbRespLayout,
        store,
        query: sbRespRoot,
        containerId: 'page',
        queue,
        actions,
    });
});
